import { useTranslation } from '../../../utils/useTranslation';
import { Dialog, DialogContent, DialogTitle } from '../../feedback/Dialog';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { AdvertisingProductCard } from '../AdvertisingProductCard/AdvertisingProductCard';
import type { AdvertisingProductOffersDialogProps } from './types';

export const AdvertisingProductOffersDialog: React.FC<AdvertisingProductOffersDialogProps> = ({
    offers,
    onClose,
}) => {
    const t = useTranslation();

    return (
        <Dialog onClose={onClose} maxWidth={{ xs: '100%', sm: '616px' }}>
            <DialogTitle onClose={onClose} withBorderBottom={false}>
                <Typography variant="title3" weight="medium">
                    {t('Выберите предложение')}
                </Typography>
            </DialogTitle>
            <DialogContent p={0}>
                <Flex direction="row" spacing={1} width="100%" flexWrap="wrap">
                    {offers.map((offer) => (
                        <AdvertisingProductCard
                            name={offer.title}
                            image={offer.image}
                            price={offer.price?.integerPart}
                            offers={[offer]}
                            width={{ xs: 'calc(50% - 4px)', sm: 'calc(100% / 3 - 6px)' }}
                        />
                    ))}
                </Flex>
            </DialogContent>
        </Dialog>
    );
};
